module.exports = __webpack_public_path__ + "img/platform-logo-vcheck.c3a0f142.png";